import {Box, BusinessBadge, Grid, Image, Radio, Slot as BaseSlot, Text, Trail} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useBinaryState} from '@yandex-delivery/hooks'
import type {CSSProperties, ReactElement} from 'react'
import {memo, useCallback} from 'react'

import {EventGoal, useFormUserEventHandler} from '../../lib/metrika'
import {tagToUrl} from '../../lib/tagToUrl'
import {renderWidget} from '..'
import * as slotStyles from '../Slot/Slot.classes'
import {SlotBody} from '../Slot/SlotBody'
import type {IconSpotWidgetConfig, SlotWidgetBody, SlotWidgetProps as Props} from '../types'
import * as classes from './BusinessOfferSlot.classes'
import {BusinessModal} from './Modal'

const ALIGN_TO_JUSTIFY_CONTENT_MAP: Record<SlotWidgetBody['align'], CSSProperties['justifyContent']> = {
  leading: 'left',
  center: 'center',
  trailing: 'right',
}

export const BusinessOfferSlot = memo(({config: {slot}}: Props): ReactElement => {
  const {lead, body1, body2, body3, trail1} = slot
  const i18n = useI18n()
  const [isOpen, open] = useBinaryState()
  const {icon_spot} = trail1 as IconSpotWidgetConfig

  const handleReachGoal = useFormUserEventHandler()

  const handleOpen = useCallback(() => {
    handleReachGoal(EventGoal.B2BOfferClick)
    open()
  }, [handleReachGoal, open])

  return (
    <BaseSlot onClick={handleOpen}>
      <Box alignItems="center" className={slotStyles.box} justifyContent="space-between">
        {lead && renderWidget(lead)}
        <Grid className={slotStyles.grid} direction="row">
          {body1 && (
            <Box
              className={slotStyles.box}
              flexDirection="column"
              justifyContent={ALIGN_TO_JUSTIFY_CONTENT_MAP[body1.align]}
            >
              <Box className={classes.title}>
                {body1.title && <Text className={classes.text}>{body1.title.items.map(renderWidget)}</Text>}
                <BusinessBadge>{i18n('bdui.business-badge', 'Бизнес')}</BusinessBadge>
              </Box>
              {body1.subtitle && <Text className={classes.text}>{body1.subtitle.items.map(renderWidget)}</Text>}
            </Box>
          )}
          {body2 && <SlotBody body={body2} />}
          {body3 && <SlotBody body={body3} />}
        </Grid>
        <Box flexDirection="row" gap="s">
          <div
            className={classes.iconSpotWrapper}
            style={icon_spot.background_color ? {backgroundColor: icon_spot.background_color} : {}}
          >
            <Image height={20} src={tagToUrl(icon_spot.icon.image_tag)} />
          </div>
          <Trail mr="s">
            {/* Этот радиобаттон нельзя выбрать, потому что по расчётному счёту можно оплачивать только в ЛК */}
            <Radio />
          </Trail>
        </Box>
      </Box>
      <BusinessModal onClose={close} opened={isOpen} utmSource="order_offer" />
    </BaseSlot>
  )
})
